export const daysFromTodayToDateString = (days: number): string => {
  const cutoffDateTime = new Date();
  cutoffDateTime.setDate(cutoffDateTime.getDate() + days);
  return getDateOnly(cutoffDateTime);
};

export const getDateOnly = (date: Date): string => {
  const [dateOnly] = date.toISOString().split('T');
  return dateOnly;
};

export const getLocalTimeWithoutTimezone = (date: Date): string => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return localDate.toISOString().slice(0, 16);
};
